
const settings = {
    changeDelay: {
        default: 20,
        response: 35,
        deliberate: 50,
        slow: 70,
        verySlow: 100,
        snail: 150
    },
    pauseAfterTypingALine: {
        response: 1300,
        standard: 800
    },
    pauseFor: {
        comma: 300,
        fullStop: 500
    }
}

export default settings
